import React from "react";
import poster from "../assets/poster/Poster.png";
import mainpaper from "../assets/paper/paper.pdf";
import supplemental from "../assets/paper/supplementary.pdf";
import Method from "../assets/method/method.png";
import dummyResults from "../assets/validation_2D.png";

const Navbar = () => {
  const buttonStyle = {
    backgroundColor: 'black',
    color: 'white',
    borderRadius: '50px',
    padding: '10px 20px',
    border: 'none',
    cursor: 'pointer',
    textDecoration: 'none',
    marginRight: '10px',
  };

  const lineStyle = {
    width: '100%',
    height: '2px',
    backgroundColor: 'black',
    marginBottom: '10px',
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light" style={{ backgroundColor: "#ffffff", padding: "2rem 1rem" }}>
      <div className="container d-flex flex-column align-items-center">
        <div className="d-flex justify-content-center w-100">
          <a className="navbar-brand nav-link-item head-name text-center" href="" style={{ color: "black", fontFamily: "Times New Roman", fontSize: "2rem", fontWeight: "bold" }}>
            Direct Flow Simulations with Implicit Neural Representation of Complex Geometry
          </a>
        </div>
        <div className="d-flex justify-content-center w-100">
          <div className="text-center" style={{ fontSize: "1rem", marginTop: "1rem" }}>
            <p>
              <span style={{ color: "#1a0dab", fontWeight: "bold" }}>
                <a href="https://www.linkedin.com/in/samundra-karki-1aa8ab176/">Samundra Karki</a><sup>1</sup>,
                <a href="https://www.linkedin.com/in/mehdi-shadkhah/">Mehdi Shadkhah</a><sup>1</sup>,
                <a href="https://www.linkedin.com/in/ychenghau/">Cheng-Hau Yang</a><sup>1</sup>,
                <a href="https://scholar.google.com/citations?user=GNuXi6oAAAAJ&hl=en&oi=ao">Aditya Balu</a><sup>1</sup>,
                <a href="https://scholar.google.com/citations?user=lJDpUU0AAAAJ&hl=en&oi=ao">Guglielmo Scovazzi</a><sup>2</sup>,
                <a href="https://scholar.google.com/citations?user=iVTMSxoAAAAJ&hl=en&oi=ao">Adarsh Krishnamurthy</a><sup>1*</sup>,
                <a href="https://www.me.iastate.edu/bglab/">Baskar Ganapathysubramanian</a><sup>1*</sup>
              </span>
            </p>
            <p><span style={{ color: "#5f6368" }}><sup>1</sup>Iowa State University, <sup>2</sup>Duke University</span></p>
            <img src={poster} alt="Poster" style={{ maxWidth: "50%", marginTop: "0.8rem" }} />
          </div>
        </div>
        <hr style={lineStyle} />
        <div className="black-box d-flex justify-content-between w-100 mt-4" style={{ gap: "10px" }}>
          <button className="nav-btn" style={buttonStyle}><a href={mainpaper} className="nav-link" target="_blank" rel="noopener noreferrer">Paper</a></button>
          <button className="nav-btn" style={buttonStyle}><a href={supplemental} className="nav-link" target="_blank" rel="noopener noreferrer">Supplemental</a></button>
        </div>
      </div>
    </nav>
  );
};

const About = () => {
  return (
    <section className="pt-2" style={{ background: "#fafbfc", minHeight: "100vh" }}>
      <Navbar />
      <div className="container py-4">
        <div className="row justify-content-center">
          <div className="col-lg-10 col-xl-8">


            {/* Abstract */}
            <div
              className="mb-4 shadow-sm"
              style={{
                background: "linear-gradient(90deg, #e0e0e0 60%, #f5f5f5 100%)",
                color: "#222",
                padding: "2rem 2rem 1.5rem 2rem",
                borderRadius: "1rem",
                border: "1px solid #e3e3e3",
              }}
            >
              <span
                className="greeting"
                style={{
                  fontSize: "2rem",
                  fontWeight: 600,
                  letterSpacing: "0.5px",
                  color: "#2d2d2d",
                  display: "block",
                  marginBottom: "0.5rem",
                }}
              >
                Abstract
              </span>
              <p
                style={{
                  color: "#444",
                  fontSize: "1.05rem",
                  textAlign: "justify",
                  marginBottom: 0,
                  lineHeight: 1.7,
                }}
              >
                Implicit neural representations (e.g., neural network-based signed distance fields) have emerged as a powerful approach for encoding complex geometries as continuous functions. These implicit models are widely used in computer vision and 3D content creation, but their integration into scientific computing workflows, such as finite element or finite volume simulations, remains limited. One reason is that conventional simulation pipelines require explicit geometric inputs (meshes), forcing INR-based shapes to be converted to meshes—a step that introduces approximation errors, computational overhead, and significant manual effort. Immersed boundary methods partially alleviate this issue by allowing simulations on background grids without body-fitted meshes. However, they still require an explicit boundary description and can suffer from numerical artifacts, such as sliver cut cells. The shifted boundary method (SBM) eliminates the need for explicit geometry by using grid-aligned surrogate boundaries, making it inherently compatible with implicit shape representations. Here, we present a framework that directly couples neural implicit geometries with SBM to perform high-fidelity fluid flow simulations without any intermediate mesh generation. By leveraging neural network inference, our approach computes the surrogate boundary and distance vectors required by SBM on-the-fly directly from the INR, thus completely bypassing traditional geometry processing. We demonstrate this approach on canonical 2D and 3D flow benchmarks (lid-driven cavity flows) and complex geometries (gyroids, the Stanford bunny, and AI-generated shapes), achieving simulation accuracy comparable to conventional mesh-based methods. This work highlights a novel pathway for integrating AI-driven geometric representations into computational physics, establishing INRs as a versatile and scalable tool for simulations and removing a long-standing bottleneck in geometry handling.
              </p>
            </div>

            {/* Key Contributions */}
            <section
              className="mb-4"
              style={{
                padding: "2rem",
                background: "#fff",
                borderRadius: "1rem",
                border: "1px solid #e3e3e3",
                boxShadow: "0 2px 8px rgba(0,0,0,0.03)",
              }}
            >
              <h3 style={{ fontWeight: 600, color: "#1a237e", marginBottom: "1rem" }}>Key Contributions</h3>
              <ul style={{ fontSize: "1.05rem", color: "#333", paddingLeft: "1.5rem", lineHeight: 1.7 }}>
                <li>Direct integration of INRs with SBM, bypassing mesh generation.</li>
                <li>Validation against traditional simulations on 2D and 3D lid-driven cavity flows.</li>
                <li>Application to complex shapes like gyroids, Stanford bunny, and AI-generated airplanes.</li>
                <li>Scalable, accurate, and automation-friendly simulation pipeline.</li>
              </ul>
            </section>

            {/* Method Overview */}
            <section
              className="mb-4"
              style={{
                padding: "2rem",
                background: "linear-gradient(90deg, #f0f0f0 60%, #e8eaf6 100%)",
                borderRadius: "1rem",
                border: "1px solid #e3e3e3",
              }}
            >
              <h3 style={{ fontWeight: 600, color: "#1565c0", marginBottom: "1rem" }}>Method Overview</h3>
              <p style={{ color: "#444", fontSize: "1.05rem", lineHeight: 1.7 }}>
                In traditional simulations using a boundary-fitted or immersed approach, implicit geometry is converted to explicit representation. In our approach, the Implicit Neural Representations is directly used to obtain the distance vector and the surrogate boundary for simulations using the shifted boundary method (SBM).
              </p>
              <div className="text-center">
                <img
                  src={Method}
                  alt="Method Workflow"
                  style={{
                    maxWidth: "100%",
                    marginTop: "1.2rem",
                    borderRadius: "12px",
                    boxShadow: "0 2px 12px rgba(0,0,0,0.07)",
                  }}
                />
              </div>
            </section>

            {/* Validation */}
            <section
              className="mb-4"
              style={{
                padding: "2rem",
                background: "#fff",
                borderRadius: "1rem",
                border: "1px solid #e3e3e3",
                boxShadow: "0 2px 8px rgba(0,0,0,0.03)",
              }}
            >
              <h3 style={{ fontWeight: 600, color: "#388e3c", marginBottom: "1rem" }}>Validation: Lid-Driven Cavities</h3>
              <div className="text-center" style={{ marginBottom: "1.2rem" }}>
                <img
                  src={dummyResults}
                  alt="Lid-Driven Cavity Results"
                  style={{
                    maxWidth: "100%",
                    borderRadius: "12px",
                    boxShadow: "0 2px 12px rgba(0,0,0,0.07)",
                  }}
                />
              </div>
              <p style={{ color: "#444", fontSize: "1.05rem", lineHeight: 1.7 }}>
                Validation on canonical geometries shows excellent agreement with mesh-based solvers:
              </p>
              <ul style={{ fontSize: "1.05rem", color: "#333", paddingLeft: "1.5rem", lineHeight: 1.7 }}>
                <li>2D Lid-Driven Cavity with circular obstacle (Re = 100–5000)</li>
                <li>3D Lid-Driven Cavity with embedded objects</li>
              </ul>
            </section>

            {/* Demonstration: Stanford Bunny */}
            <section
              className="mb-4"
              style={{
                padding: "2rem",
                background: "#fff",
                borderRadius: "1rem",
                border: "1px solid #e3e3e3",
                boxShadow: "0 2px 8px rgba(0,0,0,0.03)",
              }}
            >
              <h3 style={{ fontWeight: 600, color: "#1976d2", marginBottom: "1rem" }}>Demonstration: Stanford Bunny</h3>
              <div className="text-center">
                <img
                  src={require("../assets/results/bunny.png")}
                  alt="Stanford Bunny Result"
                  style={{
                    maxWidth: "70%",
                    borderRadius: "12px",
                    boxShadow: "0 2px 12px rgba(0,0,0,0.07)",
                  }}
                />
              </div>
            </section>

            {/* Demonstration: AI-Generated Airplane */}
            <section
              className="mb-4"
              style={{
                padding: "2rem",
                background: "#fff",
                borderRadius: "1rem",
                border: "1px solid #e3e3e3",
                boxShadow: "0 2px 8px rgba(0,0,0,0.03)",
              }}
            >
              <h3 style={{ fontWeight: 600, color: "#1976d2", marginBottom: "1rem" }}>Demonstration: AI-Generated Airplane</h3>
              <div className="text-center">
                <img
                  src={require("../assets/results/airplane.png")}
                  alt="AI-Generated Airplane Result"
                  style={{
                    maxWidth: "70%",
                    borderRadius: "12px",
                    boxShadow: "0 2px 12px rgba(0,0,0,0.07)",
                  }}
                />
              </div>
            </section>

            {/* Demonstration: This is should be in the demonstration section as well */}
            <section
              className="mb-4"
              style={{
                padding: "2rem",
                background: "#fff",
                borderRadius: "1rem",
                border: "1px solid #e3e3e3",
                boxShadow: "0 2px 8px rgba(0,0,0,0.03)",
              }}
            >
              <h3 style={{ fontWeight: 600, color: "#1976d2", marginBottom: "1rem" }}>Demonstration: Gyroid</h3>
              <div className="text-center">
                <img
                  src={require("../assets/results/gyroid.png")}
                  alt="AI-Generated Airplane Result"
                  style={{
                    maxWidth: "70%",
                    borderRadius: "12px",
                    boxShadow: "0 2px 12px rgba(0,0,0,0.07)",
                  }}
                />
              </div>
            </section>

            <section
              className="mb-4"
              style={{
                padding: "2rem",
                background: "#f8f8f8",
                borderRadius: "1rem",
                border: "1px solid #e3e3e3",
              }}
            >
              <h3 style={{ fontWeight: 600, color: "#6d4c41", marginBottom: "1rem" }}>How to Cite</h3>
              <pre
                style={{
                  background: "#eee",
                  padding: "1.2rem",
                  borderRadius: "0.5rem",
                  fontSize: "0.95rem",
                  overflowX: "auto",
                  color: "#222",
                  border: "1px solid #e0e0e0",
                }}
              >{`@article{karki2025direct,
  title={Direct flow simulations with implicit neural representation of complex geometry},
  author={Karki, Samundra and Shadkhah, Mehdi and Yang, Cheng-Hau and Balu, Aditya and Scovazzi, Guglielmo and Krishnamurthy, Adarsh and Ganapathysubramanian, Baskar},
  journal={Computer Methods in Applied Mechanics and Engineering},
  volume={446},
  year={2025},
  publisher={Elsevier},
  doi={10.1016/j.cma.2025.118248}
}`}</pre>
            </section>

          </div>
        </div>
      </div>
    </section>
  );
};

export default About;